/**
 * All JavaScript/jQuery for standard pages on the WP-ET
 *
 * @author Chris Barnes http://www.cjbarnes.co.uk/
 */

(function($) {

/* BEGIN jQUERY
   ========================================================================== */

/**
 * Confirm JavaScript is turned on
 */
$(function confirmJavascriptSupport() {
  $('html')
    .removeClass('no-js')
    .addClass('js');
});



/* END jQUERY =============================================================== */

})(jQuery);
